import React from "react";
import NewScoreGrade from "./NewScoreGrade";
import PlusIcon from "../../elements/icons/PlusIcon";
import ModalDialog from "../../layouts/ModalDialog";
import { ERROR, SET_SUCCESS } from "../../../store/types";
import { authHeader, baseUrl } from "../../../utils";
import axios from "axios";
import { useDispatch } from "react-redux";
import TrashIcon from "../../elements/icons/TrashIcon";
import EmptyState from "../../elements/EmptyState";

const ScoreGrades = ({grades, reload}) => {
  const [creatingScoreGrade, setCreatingScoreGrade] = React.useState(false);
  const dispatch = useDispatch();

  const handleDeleteGrade = async (id) => {
    if (
      window.confirm(
        "Are you sure you want to delete this grade? This action cannot be undone.",
      )
    ) {
      try {
        const headers = authHeader();
        await axios.delete(
          `${baseUrl}/academic-settings/score-grade/${id}`,
          { headers },
        );
        dispatch({
          type: SET_SUCCESS,
          payload: "Score grade removed successfully",
        });
        reload();
      } catch (error) {
        console.log("error removing score grade: ", error);
        dispatch({
          type: ERROR,
          error,
        });
      }
    }
  };
  return (
    <>
      {grades?.length > 0 ? (
        <div className="w-full">
          {grades.map((grade, index) => (
            <div
              key={index}
              className="w-full rounded-lg flex items-center justify-between gap-x-2 bg-white p-5 mb-2 border border-gray-200 relative"
            >
              <div className="w-3/12 flex items-center gap-x-2">
                <h3 className="font-semibold text-sm text-gray-800">
                  {grade.grade}
                </h3>
                {grade.passingGrade ? (
                  <span className="text-xs text-green-800 bg-green-100 px-2 py-1 rounded-lg font-medium">
                    Pass
                  </span>
                ): (
                  <span className="text-xs text-gray-600 bg-gray-100 px-2 py-1 rounded-lg font-medium">
                    Fail
                  </span>
                )}
              </div>
              <div className="w-4/12">
                <p className="text-sm text-gray-500">
                  Score Range: {grade.minScore}% - {grade.maxScore}%
                </p>
              </div>
              <div className="w-3/12">
                <p className="text-sm text-gray-500 capitalize">
                  Types: {grade?.classTypes?.join(', ')?.toLowerCase() || 'None'}
                </p>
              </div>
              <div className="w-2/12 flex flex-row-reverse items-center gap-x-2">
                <button
                  onClick={() => {
                    handleDeleteGrade(grade._id);
                  }}
                  className="p-1.5 bg-gray-100 rounded bg-transparent hover:bg-red-100 transition duration-200 text-xs flex items-center justify-center gap-x-1 text-gray-500 hover:text-vcm-purple"
                >
                  <TrashIcon className={`w-4 h-4`} />
                  Remove
                </button>
              </div>
              
            </div>
          ))}
        </div>
      ) : (
        <EmptyState
          emptyStateTitle={`No grades found.`}
          emptyStateText={`No score grades have been set yet. Click the button below to add a new score grade.`}
        />
      )}
      <button
        onClick={() => {
          setCreatingScoreGrade(true);
        }}
        className="w-max mx-auto p-3 text-xs border border-dashed border-gray-500 bg-white transition duration-200 flex items-center justify-center gap-x-1 text-gray-800 rounded-lg mt-2 font-space-grotesk font-semibold"
      >
        <PlusIcon className={`w-4 h-4 inline-block`} />
        Add New Score Grade
      </button>

      <ModalDialog
        shown={creatingScoreGrade}
        closeFunction={() => {
          setCreatingScoreGrade(false);
        }}
        actionFunction={() => {}}
        actionFunctionLabel={``}
        dialogTitle={`Create a New Score Grade`}
        maxWidthClass="max-w-xl"
        hideActions={true}
      >
        <NewScoreGrade
          close={() => setCreatingScoreGrade(false)}
          reload={reload}
        />
      </ModalDialog>
    </>
  );
};

export default ScoreGrades